'use client'

import { Stack, type StackProps } from '@mantine/core'

type AppModalBodyProps = StackProps

export default function AppModalBody({ gap = 'xl', ...props }: AppModalBodyProps) {
    return <Stack gap={gap} {...props} />
}
